export default (productID, remove = false) => ({
    remove: false,

    init() {
        if (remove == true) {
            this.remove = !this.remove
        }
    },

    toggleWishList() {
        if (this.remove == false) {
            this.addWishList();
        } else {
            this.removeWishList();
        }

        this.remove = !this.remove
    },

    addWishList() {
        this.request('ProductList::onAddToWishList', {
            data: {product_id: productID},
            update: { 'common/header/fovorite': '.js-fovorite' },
            loading: '.preloader-selector'
        });
    },

    removeWishList() {
        this.request('ProductList::onRemoveFromWishList', {
            data: {product_id: productID},
            update: { 'common/header/fovorite': '.js-fovorite' },
            loading: '.preloader-selector'
        });
    },

    clearWishList(productID) {

        this.request('ProductList::onClearWishList', {
            loading: '.preloader-selector'
        });
    }

})